import React from 'react';
const SvgPdf = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <path fill="#5C7896" d="M3 1v30h26V8h-7V1H3z" />
      <path fill="#FFF" d="M4 2v20h24V8h-6V2H4z" />
      <path opacity={0.3} fill="#1B3F63" d="M29 15l-7-7h7v7z" />
      <path fill="#769CC2" d="M22 1l7 7h-7V1z" />
      <g fill="#FFF">
        <path d="M10.1 29v-4.7h1.7c1 0 1.9.4 1.9 1.4 0 1.1-.9 1.5-1.9 1.5h-.6V29h-1.1zm1-2.4h.4c.6 0 1.1-.1 1.1-.8 0-.6-.4-.8-1-.8h-.4v1.6zM14.3 29v-4.7h1.6c1.5 0 2.5.7 2.5 2.3 0 1.6-1.1 2.4-2.6 2.4h-1.5zm1-.7h.3c1.1 0 1.7-.6 1.7-1.7 0-1-.6-1.6-1.5-1.6h-.4v3.3zM19.2 29v-4.7h3v.7h-2v1.3h1.9v.7h-1.9v2h-1z" />
      </g>
      <g>
        <g fill="#5C7896">
          <path d="M16 5h5v2h-5zM16 9h8v2h-8zM8 13h16v2H8zM8 17h12v2H8zM8 5h6v6H8z" />
        </g>
      </g>
    </svg>
  );
});
export default SvgPdf;
SvgPdf.iconName = 'pdf';
SvgPdf.displayName = 'SvgPdf';
